module.exports = {
    moduleName: 'frame' // 模块名称
};